var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0C35.684 0 46 10.318 46 23C46 35.684 35.684 46 23 46C10.318 46 0 35.684 0 23C0 10.318 10.318 0 23 0Z",
    fill: "#3186D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.15 19.8037C33.161 20.0007 33.167 20.1987 33.167 20.3977V24.2297C33.167 28.6087 30.399 32.3387 26.52 33.7707",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.39 34.0049C26.39 35.0169 25.569 35.8368 24.557 35.8368H21.607C20.594 35.8368 19.774 35.0169 19.774 34.0049C19.774 32.9929 20.594 32.1729 21.607 32.1729H24.557C25.568 32.1729 26.39 32.9929 26.39 34.0049Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.746 19.1895C10.08 19.1895 9.54102 19.7285 9.54102 20.3945V25.3785C9.54102 26.0445 10.08 26.5835 10.746 26.5835H12.833V19.1885H10.746V19.1895Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.254 19.1895C35.92 19.1895 36.459 19.7285 36.459 20.3945V25.3785C36.459 26.0445 35.92 26.5835 35.254 26.5835H33.167V19.1885H35.254V19.1895Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.833 20.3501C12.833 14.7251 17.395 10.1641 23.021 10.1641C28.647 10.1641 33.209 14.7251 33.209 20.3501",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.18bdcd5f641b263ba6bc902aae089043.svg";
export { ForwardRef as ReactComponent };